import {
  faCalendarCheck,
  faCalendarEdit,
  faCalendarExclamation,
  faCalendarPlus,
} from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'src/app/hooks';
import { Role } from 'src/store/models/Auth';
import { ListTicket, TicketStatus } from 'src/store/models/Ticket';

import DateTooltip from '../DateTooltip/DateTooltip';
import classes from './DateIndicator.module.scss';

export interface DateIndicatorProps {
  ticket: ListTicket;
}

const DateIndicator: FC<DateIndicatorProps> = ({ ticket }) => {
  const { t } = useTranslation();
  const status = ticket?.status;

  const user = useAppSelector((state) => state.auth.user);
  const isService = user?.role === Role.SERVICE;
  const isManufacturer = user?.role === Role.MANUFACTURER;

  return (
    <div className={classes.Container}>
      {isManufacturer && (
        <DateTooltip
          tooltipTitle={t('tickets:report_date')}
          icon={faCalendarExclamation}
          date={ticket?.createdAt}
        />
      )}
      {(isService ||
        (isManufacturer &&
          (status === TicketStatus.TO_DO ||
            status === TicketStatus.IN_PROGRESS ||
            status === TicketStatus.RESOLVED))) && (
        <DateTooltip
          tooltipTitle={t('tickets:assign_date')}
          icon={faCalendarPlus}
          date={ticket?.assignedAt}
        />
      )}
      {status === TicketStatus.IN_PROGRESS ||
      status === TicketStatus.RESOLVED ? (
        <DateTooltip
          tooltipTitle={t('tickets:start_date')}
          icon={faCalendarEdit}
          date={ticket?.startedAt}
        />
      ) : null}
      {status === TicketStatus.RESOLVED ? (
        <DateTooltip
          tooltipTitle={t('tickets:resolved_date')}
          icon={faCalendarCheck}
          date={ticket?.resolvedAt}
        />
      ) : null}
    </div>
  );
};

export default DateIndicator;
